// Vendor libraries
import Highcharts from 'ChartApp/ts/features/scatter-plot/highcharts';
/*
 * https://api.highcharts.com/highcharts/plotOptions.series.turboThreshold
 * MAX_POINTS_PER_SERIES represents the max number of points that Highcharts can display. Technically after
 * this threshold we can display very simple plots with only an array of numbers (e.g. no tooltips),
 * but we don't currently have that capability.
 */
export const MAX_POINTS_PER_SERIES = 3000;
export const SCATTER_PLOT_HIGHCHARTS_PLOT_OPTIONS_INTERACTIVE_DEFAULT = {
    chart: {
        displayErrors: false,
        height: null,
        panKey: 'shift',
        panning: {
            enabled: false,
            type: 'xy',
        },
        plotBackgroundColor: 'transparent',
        backgroundColor: 'transparent',
        plotBorderColor: '#e5e5e5',
        plotBorderWidth: 1,
        reflow: true,
        renderTo: '', // id of the HTML element where the chart will be rendered
        // Disable Highcharts reset zoom button because we are using our own custom button
        resetZoomButton: {
            theme: {
                style: {
                    display: 'none',
                },
            },
        },
        scrollablePlotArea: {
            minHeight: undefined,
            minWidth: undefined,
            scrollPositionX: 0,
            scrollPositionY: 1,
        },
        spacing: [15, 15, 15, 15],
        style: {
            fontFamily: 'Roboto Condensed, sans-serif',
            cursor: 'default',
        },
        type: 'scatter',
        width: null,
        zooming: { type: 'xy', mouseWheel: false },
    },
    credits: {
        enabled: false,
    },
    exporting: {
        enabled: false,
    },
    legend: {
        enabled: false,
    },
    noData: {
        style: {
            fontSize: '30px',
        },
    },
    navigator: {
        enabled: false,
    },
    title: {
        text: '',
    },
    tooltip: {
        backgroundColor: undefined,
        borderColor: undefined,
        borderRadius: 0,
        borderWidth: 0,
        enabled: undefined,
        followPointer: true,
        followTouchMove: false,
        shadow: false,
        useHTML: true,
        valueDecimals: 2,
        style: {
            color: 'auto',
        },
    },
    rangeSelector: { enabled: false },
    series: [],
    scrollbar: { enabled: false },
    xAxis: {
        lineColor: '#e5e5e5',
        tickColor: '#e5e5e5',
        className: 'chart-axis-x chart-axis-x-item',
        crosshair: {
            color: '#808080',
            dashStyle: 'Solid',
            snap: false,
            width: 1,
        },
        endOnTick: false,
        gridLineWidth: 1,
        id: 'xAxis',
        labels: {
            formatter: undefined,
            style: {
                fontSize: '11',
                color: '#666',
            },
        },
        ordinal: false,
        maxPadding: 0.05,
        minPadding: 0.2, // Allows for labels to not run off plot area.
        startOnTick: false,
        title: {
            text: '',
        },
    },
    yAxis: {
        lineColor: '#e5e5e5',
        className: 'chart-axis-y chart-axis-y-item',
        crosshair: {
            color: '#808080',
            dashStyle: 'Solid',
            snap: false,
            width: 1,
        },
        endOnTick: false,
        gridLineWidth: 1,
        id: 'yAxis',
        labels: {
            formatter: undefined,
            style: {
                fontSize: '11',
                color: '#666',
            },
        },
        maxPadding: 0.2,
        minPadding: 0.2,
        startOnTick: false,
        title: {
            text: '',
        },
    },
    plotOptions: {
        series: {
            point: {
                events: {
                    click: undefined,
                },
            },
            turboThreshold: MAX_POINTS_PER_SERIES,
        },
        scatter: {
            dataLabels: {
                align: 'right',
                allowOverlap: true,
                crop: false,
                enabled: undefined,
                useHTML: true,
                x: 1,
                y: 5,
            },
            marker: {
                radius: undefined,
            },
            opacity: 1,
            states: {
                inactive: {
                    opacity: 1,
                },
            },
        },
    },
};
export const SCATTER_PLOT_HIGHCHARTS_PLOT_OPTIONS_PRESENTATION_DEFAULT = Highcharts.merge(SCATTER_PLOT_HIGHCHARTS_PLOT_OPTIONS_INTERACTIVE_DEFAULT, {
    chart: {
        animation: false,
        events: {
            render: () => {
                // @ts-ignore
                window.ycharts.chartLoadedResolver();
            },
        },
    },
    plotOptions: {
        series: {
            animation: false,
        },
        scatter: {
            dataLabels: {
                animation: { defer: 0 },
            },
        },
    },
});
export const SCATTER_PLOT_HIGHCHARTS_PLOT_OPTIONS_EFFICIENT_FRONTIER_DEFAULT = Highcharts.merge(SCATTER_PLOT_HIGHCHARTS_PLOT_OPTIONS_INTERACTIVE_DEFAULT, {
    plotOptions: {
        series: {
            dataLabels: {
                zIndex: 1,
                allowOverlap: true,
                useHTML: false,
                shape: 'callout',
            },
        },
        scatter: {
            dataLabels: {
                useHTML: false,
                x: 0,
                y: 0,
            },
        },
    },
    chart: {
        spacing: [0, 0, 0, 0],
    },
    xAxis: {
        maxPadding: 0.1,
        minPadding: 0,
    },
    yAxis: {
        maxPadding: 0.1,
        minPadding: 0.02,
    },
});
export const SCATTER_PLOT_HIGHCHARTS_PLOT_OPTIONS_PRESENTATION_EFFICIENT_FRONTIER = Highcharts.merge(SCATTER_PLOT_HIGHCHARTS_PLOT_OPTIONS_PRESENTATION_DEFAULT, {
    chart: {
        spacing: [0, 0, 0, 0],
    },
    xAxis: {
        maxPadding: 0.1,
        minPadding: 0,
    },
    yAxis: {
        maxPadding: 0.1,
        minPadding: 0.02,
    },
});
